import { ChangeDetectionStrategy, Component, Input } from '@angular/core'

@Component({
  selector: 'bmcore-shuffle-icon',
  templateUrl: './bmcore-shuffle-icon.component.html',
  styleUrls: ['./bmcore-shuffle-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreShuffleIconComponent {
  @Input() fillColor = 'currentColor'
  @Input() width = 24
  @Input() height = 24
}
